module.exports = __webpack_public_path__ + "img/ico_market.6e19cb43.svg";